import domain from "./DomainService";
import { WARM_DASHBOARD_API_BASE, GENERATE_COMMENT_API_BASE } from "./apiEndpoints";

/** Fetches the user's tones (defaults + saved), same source the Chrome extension uses. */
export function GetTonesService(email) {
  return fetch(WARM_DASHBOARD_API_BASE + "/getUserTonesEndpointV2", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
    body: JSON.stringify({ email }),
  });
}

/** Generates an AI comment for a LinkedIn post given a tone's prompt, same backend the extension uses. */
export function GenerateLinkedInCommentService({ post_url, post, prompt, word_limit, current_plan, email }) {
  return fetch(GENERATE_COMMENT_API_BASE + "/generateCommentEndpoint", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
    body: JSON.stringify({
      post_url,
      post,
      prompt,
      word_limit,
      nested_comments: [],
      images: [],
      current_plan,
      email,
    }),
  });
}

/** Submits a comment to LinkedIn on the user's behalf via kynzo-server's proxy endpoint. */
export function SubmitLinkedInCommentService({ post_url, comment, post_owner, post_id }) {
  const token = localStorage.getItem("token");
  return fetch(domain() + "submit-linkedin-comment", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
    body: JSON.stringify({ post_url, comment, post_owner, post_id }),
  });
}

/**
 * The generate-comment endpoint can return a bare string, {response}, or {message}
 * depending on path taken server-side - normalize all three down to a single string.
 */
export function parseGeneratedComment(rawText) {
  if (typeof rawText !== "string") return "";
  try {
    const parsed = JSON.parse(rawText);
    if (typeof parsed === "string") return parsed;
    if (typeof parsed?.response === "string") return parsed.response;
    if (typeof parsed?.message === "string") return parsed.message;
  } catch {
    // Not JSON - the raw text itself is the comment.
  }
  return rawText;
}
